<template>
  <page-view title>
    <a-card
      style="width: 100%"
      :tab-list="tabListNoTitle"
      :active-tab-key="noTitleKey"
      @tabChange="key => onTabChange(key, 'noTitleKey')"
    >
      <div v-if="noTitleKey === '0'">
        <div slot="headerContent">
          <search-robot @changeRobotId="onChangeRobotId"></search-robot>
        </div>

        <div :style="{ marginBottom: '10px' }">
          <demo-video-alert name="CaiWuGuanLi"></demo-video-alert>
        </div>

        <exception-page type="norobot" v-if="!currentRobotId" />

        <div style="margin-top: 24px" v-if="currentRobotId">
          <a-card :bordered="false">
            <a-row>
              <a-col :sm="6" :xs="24">
                <head-info title="全部提现" :content="`${statistics.total_number}个`" :bordered="true" />
              </a-col>
              <a-col :sm="6" :xs="24">
                <head-info title="已领取" :content="`${statistics.finished}个`" :bordered="true" />
              </a-col>
              <a-col :sm="6" :xs="24">
                <head-info title="待审核" :content="`${statistics.need_operate}个`" />
              </a-col>
              <a-col :sm="6" :xs="24">
                <head-info title="待审核金额" :content="`${statistics.need_operate_sum}元`" />
              </a-col>
            </a-row>
          </a-card>

          <a-alert style="margin-top: 24px" type="warning" closable>
            <span slot="message">
              此页面红包领取状态可能存在延迟，实时状态请复制红包码前往粮仓用户端查询&nbsp;&nbsp;&nbsp;<a
                target="_blank"
                href="http://p.liangcangnc.net.cn/"
                >前往粮仓用户端</a
              >
            </span>
          </a-alert>

          <a-card style="margin-top: 24px" :bordered="false">
            <a-row :gutter="24">
              <a-col :sm="15" :xs="24">
                <!-- <div slot="title" style="display: flex; align-items: center"> -->
                <div style="display: flex; align-items: center">
                  提现列表
                  <a-button @click="getData" :style="{ marginLeft: '10px' }" size="small">刷新</a-button>
                  <!-- <a-popconfirm title="确定要将本页全部通过审核吗？" @confirm="handleAllAdopt"> -->
                  <a-button @click="getData" :style="{ marginLeft: '10px' }" size="small" :disabled="true"
                    >本页全部通过审核
                  </a-button>
                  <!-- :disabled="queryParam.type != '0'" -->
                  <!-- </a-popconfirm> -->
                  <a-input-group compact style="margin-left: 10px; width: 390px">
                    <a-select v-model="queryParam.search_condition">
                      <a-select-option :value="1">UID</a-select-option>
                      <a-select-option :value="2">红包码</a-select-option>
                    </a-select>
                    <a-input-search
                      @search="handleSearch"
                      v-model="queryParam.keywords"
                      placeholder="请输入查询内容"
                      style="width: 160px"
                    />
                    <a-input-search
                      v-model="queryParam.second_sub_id"
                      placeholder="请输入客户端ID"
                      @search="handleSearch"
                      style="margin-left: 10px; width: 160px"
                    >
                    </a-input-search>
                  </a-input-group>
                  <a-button @click="checkSubmit" v-if="passList.length != 0" type="primary">通过</a-button>
                  <a-button @click="allResend()" v-if="queryParam.redpacket_state == '0'" type="primary"
                    >未领取红包一键重发</a-button
                  >
                </div>
              </a-col>
              <!-- <a-col :sm="2" :xs="24">
                <a-button @click="checkSubmit" v-if="passList.length != 0" type="primary">通过</a-button>
              </a-col> -->
              <a-col :sm="9" :xs="24">
                <!-- <div slot="extra"> -->
                <div>
                  <a-radio-group :defaultValue="''" @change="onCapitalChange" v-model="queryParam.type">
                    <a-radio-button value>全部</a-radio-button>
                    <!-- <a-radio-button value="4">待领取</a-radio-button> -->
                    <a-radio-button value="0">等待审核</a-radio-button>
                    <a-radio-button value="2">拒绝并返还</a-radio-button>
                    <a-radio-button value="3">拒绝并扣除</a-radio-button>
                    <a-radio-button value="1">提现完成</a-radio-button>
                  </a-radio-group>
                  <a-select
                    :defaultValue="''"
                    :style="{ width: '100px', marginLeft: '10px' }"
                    @change="onRedpacketStateChange"
                    v-model="queryParam.redpacket_state"
                  >
                    <a-select-option value="">全部状态</a-select-option>
                    <a-select-option value="0">待领取</a-select-option>
                    <a-select-option value="1">已领取</a-select-option>
                  </a-select>
                  <!-- <a-input-search style="margin-left: 16px; width: 272px;"/> -->
                </div>
              </a-col>
            </a-row>
            <!-- 列表 -->
            <a-list size="large" :pagination="pagination" :loading="loading">
              <a-list-item v-for="item in list" :key="item.id">
                <!-- 勾选框 -->
                <input
                  type="checkbox"
                  ref="inputCheck"
                  style="width: 16px; height: 16px; margin-right: 15px"
                  :disabled="item.status != '0'"
                  @click="checkItem(item)"
                />

                <a-list-item-meta>
                  <div slot="description">
                    <span style="display: inline-block; margin-right: 2px"
                      >金额:{{ currency(item.money, '￥') }}元</span
                    >
                    <!-- <a-popover title='' trigger="hover">
                      <span>(备注)</span>
                    </a-popover> -->
                    <span v-if="item.redpacket_code">
                      <a-divider type="vertical" />
                      <a-tooltip placement="top">
                        <template slot="title">
                          <span>{{ item.redpacket_code }}</span>
                        </template>
                        <span>{{ item.redpacket_state | getRedpacketState }}</span>
                      </a-tooltip>
                      <a-popconfirm placement="top" v-if="item.redpacket_state == '0'" @confirm="handleDestroy(item)">
                        <template slot="title">销毁后该红包将失效，资金退还！</template>
                        <a>(销毁)</a>
                      </a-popconfirm>
                    </span>
                    <!-- <span v-if="item.packet_hash">
                      <a-divider type="vertical" />
                      <a-tooltip placement="top">
                        <template slot="title">
                          <span>{{item.packet_hash}}</span>
                        </template>
                        <span>{{item.redpacket_state | getRedpacketState}}</span>
                      </a-tooltip>
                    </span> -->
                    <a-tag style="font-size: 12px" color="red" v-if="item.is_first_tixian == 1">首次提现</a-tag>
                    <a-tag style="font-size: 12px" color="red" v-if="item.is_force == 1">强制审核</a-tag>
                  </div>

                  <a-avatar
                    slot="avatar"
                    size="large"
                    shape="square"
                    icon="user"
                    :src="item.get_member_info ? item.get_member_info.avatar : ''"
                    @click="handleFansDetail(item.get_member_info)"
                  />
                  <span slot="title" style="width: 200px">
                    <a @click="handleFansDetail(item.get_member_info)"
                      >{{ item.get_member_info ? item.get_member_info.nickname : '无' }} (UID:{{
                        item.get_member_info ? item.get_member_info.uid : '无'
                      }})</a
                    >
                    <br />
                    <a-tag @click="handleFansOrder(item.get_member_info, '', item.createdt)">查看订单</a-tag>
                    <a style="font-size: 13px">
                      <span> 最近同商品：{{ sumGoodsTotal(item.orders_total) }} 笔 </span>
                      <a-tooltip v-if="sumGoodsTotal(item.orders_total) != 0" placement="top">
                        <template slot="title">
                          <span>{{ sumGoods(item.orders_total) }}</span>
                        </template>
                        <a-icon style="margin-left: 5px; font-size: 14px" type="question-circle" />
                      </a-tooltip>
                    </a>
                    <br />
                    <a-tag @click="handleFansDetail(item.get_member_info)">个人详情</a-tag>
                    <a style="font-size: 13px">提现成功次数：{{ item.tixian_success_count }}</a>
                    <br />
                    <a-tag @click="handleFansLog(item.get_member_info)">财产日志</a-tag>
                    <!-- <a style="font-size:13px;">最近平均总佣金比例：{{ item.commission_rate }}</a> -->
                    <a style="font-size: 13px">最近平均总佣金比例：{{ showTate(item.commission_rate) }}</a>
                  </span>
                </a-list-item-meta>

                <div slot="actions">
                  <a-popconfirm title="确定要通过审核吗？" @confirm="handleAdopt(item)">
                    <a :disabled="item.status != '0'">通过</a>
                  </a-popconfirm>
                </div>

                <div slot="actions">
                  <a-dropdown :disabled="item.status != '0'">
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a @click="handleReturn(item)">拒绝并返还</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a @click="handleDeduction(item)">拒绝并扣除</a>
                      </a-menu-item>
                    </a-menu>
                    <a :disabled="item.status != '0'">
                      拒绝
                      <a-icon type="down" />
                    </a>
                  </a-dropdown>
                </div>

                <div class="list-content">
                  <div class="list-content-item">
                    <p>客户端ID: {{ item.sub_id }}</p>
                  </div>
                  <div class="list-content-item">
                    <span>红包码: </span>
                    <span>
                      <a-tag @click="handleResend(item)">重新发送</a-tag>
                    </span>
                    <p style="cursor: pointer">
                      <a-tooltip @click="doCopy(item.packet_hash)" title="复制">
                        {{ item.packet_hash ? item.packet_hash : '无' }}
                      </a-tooltip>
                    </p>
                  </div>
                  <div class="list-content-item">
                    <span>领取状态</span>
                    <!-- <p>{{ item.redpacket_state == '1' ? '已领取' : '待领取' }}</p> -->
                    <p>{{ item.redpacket_state | getRedpacketState }}</p>
                  </div>
                  <div class="list-content-item" v-if="item.changedt">
                    <span>审核时间</span>
                    <p>{{ item.changedt }}</p>
                  </div>
                  <div class="list-content-item">
                    <span>申请时间</span>
                    <p>{{ item.createdt }}</p>
                  </div>
                  <div class="list-content-item" style="width: 180px; margin-right: 50px">
                    <status-progress :status="item.status"></status-progress>
                  </div>
                </div>
              </a-list-item>
            </a-list>
          </a-card>
        </div>
      </div>

      <div v-if="noTitleKey === '1'">
        <exception-page type="norobot" v-if="!currentRobotId" />
        <div style="margin-top: 24px" v-if="currentRobotId">
          <a-card :bordered="false">
            <a-row>
              <a-col :sm="12" :xs="24">
                <head-info title="待审核数量" :content="`${toBeReviewedPagination.total}个`" :bordered="true" />
              </a-col>
              <a-col :sm="12" :xs="24">
                <head-info title="待审核金额" :content="`${totalMoney}元`" />
              </a-col>
            </a-row>
          </a-card>
          <a-card style="margin-top: 24px" :bordered="false">
            <div slot="title" style="display: flex; align-items: center">
              提现列表
              <a-button @click="getAllToBeReviewedList" :style="{ marginLeft: '10px' }" size="small">刷新</a-button>
              <a-button @click="getAllToBeReviewedList" :style="{ marginLeft: '10px' }" size="small" :disabled="true">
                本页全部通过审核</a-button
              >
              <a-input-group compact style="margin-left: 10px">
                <!-- <a-select v-model="tbrQueryParam.search_condition">
                  <a-select-option :value="1">UID</a-select-option>
                </a-select> -->
                <a-input-search
                  @search="handleTBRSearch"
                  v-model="tbrQueryParam.keywords"
                  placeholder="请输入会员UID"
                  style="width: 160px"
                />
                <a-input-search
                  v-model="tbrQueryParam.second_sub_id"
                  placeholder="请输入客户端ID"
                  @search="handleTBRSearch"
                  style="margin-left: 10px; width: 160px"
                >
                </a-input-search>
                <a-button @click="checkClientSubmit" v-if="allClientList.length != 0"  
                  style="margin-left: 10px;border-radius: 4px;" type="primary">通过</a-button>
              </a-input-group>
            </div>
            <a-list size="large" :pagination="toBeReviewedPagination" :loading="loading">
              <a-list-item v-for="item in toBeReviewedList" :key="item.id">
                <!-- 勾选框 -->
                <!-- <input type="checkbox" ref="inputCheck"
                  style="width: 16px; height: 16px; margin-right: 15px"
                  @click="checkClient(item)"
                /> -->

                <a-list-item-meta>
                  <div slot="description">
                    <span>金额:{{ currency(item.money, '￥') }}元</span>
                    <span v-if="item.redpacket_code">
                      <a-divider type="vertical" />
                      <a-tooltip placement="top">
                        <template slot="title">
                          <span>{{ item.redpacket_code }}</span>
                        </template>
                        <span>{{ item.redpacket_state | getRedpacketState }}</span>
                      </a-tooltip>
                      <a-popconfirm placement="top" v-if="item.redpacket_state == '0'" @confirm="handleDestroy(item)">
                        <template slot="title">销毁后该红包将失效，资金退还！</template>
                        <a>(销毁)</a>
                      </a-popconfirm>
                    </span>
                  </div>
                  <a-avatar
                    slot="avatar"
                    size="large"
                    shape="square"
                    icon="user"
                    :src="item.avatar"
                    @click="handleFansDetail(item, 'toBeReviewed')"
                  />
                  <span slot="title">
                    <a @click="handleFansDetail(item, 'toBeReviewed')"
                      >{{ item ? item.nickname : '无' }}（UID:{{ item ? item.member_id : '无' }}）</a
                    >
                    <a-tag @click="handleFansOrder(item, 'toBeReviewed', item.createdt)">订单</a-tag>
                    <a-tag @click="handleFansDetail(item, 'toBeReviewed')">个人详情</a-tag>
                    <a-tag @click="handleFansLog(item, 'toBeReviewed')">财产日志</a-tag>
                  </span>
                </a-list-item-meta>
                <div slot="actions">
                  <!-- <a-popconfirm title="确定要通过审核吗？" @confirm="handleAdopt(item.req_id, item.sub_id)"> -->
                  <a-popconfirm title="确定要通过审核吗？" @confirm="handleAdopt(item, 'toBeReviewed')">
                    <a>通过</a>
                  </a-popconfirm>
                </div>
                <div slot="actions">
                  <a-dropdown>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a @click="handleReturn(item, 'toBeReviewed')">拒绝并返还</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a @click="handleDeduction(item, 'toBeReviewed')">拒绝并扣除</a>
                      </a-menu-item>
                    </a-menu>
                    <a>
                      拒绝
                      <a-icon type="down" />
                    </a>
                  </a-dropdown>
                </div>

                <div class="list-content">
                  <div class="list-content-item">
                    <p>机器人ID: {{ item.sub_id }}</p>
                    <p>微信昵称：{{ item.relation_to_sub_user.nickname }}</p>
                  </div>
                  <!-- <div v-if="item.packet_hash" class="list-content-item">
                    <span>红包码: </span>
                    <p style="cursor: pointer">
                      <a-tooltip @click="doCopy(item.packet_hash)" title="复制">
                        {{ item.packet_hash }}
                      </a-tooltip>
                    </p>
                  </div>
                  <div class="list-content-item" v-if="item.packet_hash">
                    <span>领取状态</span>
                    <p>{{ item.redpacket_state | getRedpacketState }}</p>
                  </div>
                  <div class="list-content-item" v-if="item.changedt">
                    <span>审核时间</span>
                    <p>{{ item.changedt }}</p>
                  </div> -->
                  <div class="list-content-item">
                    <span>申请时间</span>
                    <p>{{ item.create_time }}</p>
                  </div>
                </div>
              </a-list-item>
            </a-list>
          </a-card>
        </div>
      </div>
    </a-card>
    <detail-drawer ref="detaildrawer"></detail-drawer>
    <order-list-modal ref="orderListModal"></order-list-modal>
    <log ref="log"></log>
    <send-msg-modal ref="sendMsgModal"></send-msg-modal>
  </page-view>
</template>

<script>
import HeadInfo from '@/components/tools/HeadInfo'
import SearchRobot from '@/views/components/SearchRobot'
import StatusProgress from '@/views/capital/components/StatusProgress'
import CapitalApi from '@/api/capital'
import { PageView } from '@/layouts'
import { currency } from '@/utils/currency'
import { regYuanToFen } from '@/utils/util'
import { ExceptionPage } from '@/components'
import { mapActions, mapState } from 'vuex'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
import DetailDrawer from '@/views/fans/detail/drawer'
import OrderListModal from '@/views/fans/order/OrderListModal'
import Log from '@/views/fans/property/log'
import SendMsgModal from './components/SendMsgModal'
import { userInfo } from 'os'
export default {
  name: 'CapitalList',
  components: {
    HeadInfo,
    PageView,
    StatusProgress,
    SearchRobot,
    ExceptionPage,
    DemoVideoAlert,
    DetailDrawer,
    OrderListModal,
    Log,
    SendMsgModal
  },

  data() {
    return {
      totalMoney: 0,
      tbrQueryParam: {
        search_condition: 1,
        keywords: '',
        second_sub_id: '',
      },
      toBeReviewedList: [],
      tabListNoTitle: [
        { key: '0', tab: '选择单个客户端处理审核' },
        { key: '1', tab: '所有客户端处理审核' },
      ],
      noTitleKey: '0',
      // 查询参数
      queryParam: {
        redpacket_state: '',
        search_condition: 1,
        keywords: '',
        second_sub_id: '',
      },
      currentRobotId: null,
      pagination: {
        showSizeChanger: true,
        pageSize: 10,
        current: 1,
        onChange: (page, pageSize) => this.handlePageChange(page, pageSize),
        onShowSizeChange: (current, size) => this.handleSizeChange(current, size),
      },
      toBeReviewedPagination: {
        showSizeChanger: true,
        pageSize: 10,
        current: 1,
        onChange: (page, pageSize) => this.handlePageTBRChange(page, pageSize),
        onShowSizeChange: (current, size) => this.handleTBRSizeChange(current, size),
        total: 0,
      },
      list: [],
      loading: false,
      statistics: {
        finished: 0,
        need_operate: 0,
        need_operate_sum: 0,
        total_number: 0,
      },
      //申请时间
      createdt: '',
      // 将选中的item，push进来
      passList: [],
      orders_total: '', // 最近同商品数
      orders_total_goods: '', // 最近同商品
      unclaimedList: [], // 红包待领取列表
      allClientList: [], // 选中的所有客户端
    }
  },

  activated() {
    // 处理跳转提现详情
    if (this.$route.params.uid) {
      this.$set(this.queryParam, 'search_condition', 1)
      this.$set(this.queryParam, 'keywords', this.$route.params.uid)
      this.$nextTick(() => {
        this.handleSearch()
      })
    }
  },

  filters: {
    getRedpacketState(status) {
      if (status == '0') {
        return '待领取'
      }
      if (status == '1') {
        return '已领取'
      }
      if (status == '2') {
        return '已失效'
      }
    },
  },

  watch: {
    noTitleKey: {
      handler(noTitleKey) {
        if (noTitleKey === '1') {
          this.getAllToBeReviewedList(true)
          this.$nextTick(() => {
            this.filterToBeReviewedList()
          })
        }
      },
      immediate: true,
    },
    'toBeReviewedPagination.current': {
      handler() {
        setTimeout(() => {
          this.$nextTick(() => {
            this.filterToBeReviewedList()
            // this.filterToBeReviewedList2()
          })
        }, 800)
      },
      deep: true,
      immediate: true,
    },
    'toBeReviewedPagination.total': {
      handler() {
        setTimeout(() => {
          this.$nextTick(() => {
            this.filterToBeReviewedList()
            // this.filterToBeReviewedList2()
          })
        }, 800)
      },
      deep: true,
    },
  },

  computed: {
    ...mapState({
      errorMsg: state => state.socket.errorMsg,
    }),
  },

  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG', 'demoSetVideo']),
    currency,

    // 最近同商品的数量
    sumGoodsTotal(list) {
      if (list.length >= 1) {
        let tempArr = list.map(item => item.item_count)
        let sum = Math.max(...tempArr)
        sum = sum ? sum : 0
        return sum
      } else {
        return 0
      }
    },

    // 哪个商品
    sumGoods(list) {
      let tempArr = list.map(item => item.item_count)
      let sum = Math.max(...tempArr)
      let tempObj = list.find(item => {
        return item.item_count == sum
      })
      // console.log('==', tempObj)
      let goods = tempObj ? tempObj.item_title : ''
      return goods
    },

    // 最近平均总佣金比例，百分比显示
    showTate(value) {
      return value != 0 ? regYuanToFen(value, 100) + '%' : '无'
    },

    onChangeRobotId(id) {
      this.currentRobotId = id
      this.getData(true)
    },

    handlePageChange(page, pageSize) {
      this.pagination.current = page
      this.getData()
    },

    // TBR-待审核-toBeReviewed
    handlePageTBRChange(page, pageSize) {
      this.toBeReviewedPagination.current = page
      this.getAllToBeReviewedList()
    },

    handleSearch(value) {
      this.getData(true)
    },

    // TBR-待审核
    handleTBRSearch(value) {
      this.getAllToBeReviewedList(true)
    },

    handleSizeChange(current, size) {
      this.pagination.pageSize = size
      this.getData()
    },

    // TBR-待审核
    handleTBRSizeChange(current, size) {
      this.toBeReviewedPagination.pageSize = size
      this.getAllToBeReviewedList()
    },

    onCapitalChange(val) {
      this.getData(true)
    },

    // 待领取
    onRedpacketStateChange(val) {
      this.getData(true)
    },

    doCopy(text) {
      this.$copyText(text)
        .then(() => {
          this.$message.success('复制成功')
        })
        .catch(e => {
          this.$message.error('复制失败')
        })
    },

    getData(first = false) {
      this.loading = true
      CapitalApi.getCapitalList(
        Object.assign(this.queryParam, {
          pageNo: first ? 1 : this.pagination.current,
          pageSize: this.pagination.pageSize,
          sub_id: this.currentRobotId,
        })
      )
        .then(res => {
          // console.log('res=', res)
          this.pagination.current = res.pageNo
          this.pagination.pageSize = res.pageSize
          this.pagination.total = res.totalCount
          this.list = res.data
          this.statistics = {
            finished: res.finished,
            need_operate_sum: res.need_operate_sum,
            need_operate: res.need_operate,
            total_number: res.total_number,
          }
          // 翻页之后
          // 清空这个数组
          this.passList = []
          // 将选择框的状态清空
          this.$refs.inputCheck &&
            this.$refs.inputCheck.map(item => {
              item.checked = false
            })

          // 如果查询条件是待领取unclaimedList
          if (this.queryParam.redpacket_state == '0') {
            this.unclaimedList = res.data
            // console.log('待领取状态列表=', this.unclaimedList)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 重新发送红包码
    handleResend({ id, sub_id }) {
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: sub_id,
        type: 'operationcapital',
        data: {
          id: [id],
          type: '5',
        },
      }).then(result => {
        this.countDown()
      })
    },

    // 未领取红包一键重发
    allResend() {
      // console.log('未领取红包列表=', this.unclaimedList)
      let retList = this.unclaimedList.filter(item => {
        return item.withdraw_url != ''
      })
      this.$refs.sendMsgModal.show(retList)
      // console.log('未领取红包列表=', retList)
      // let len = this.unclaimedList.length
      // let sub_id = ''
      // let wxid = ''
      // if (len > 0) {
      //   this.$message.success(`正在依次重新发送，大约需要${len *2}秒`)
      //   for(let i=0; i<2; i++){
      //     sub_id = this.unclaimedList[i].sub_id
      //     wxid = this.unclaimedList[i].get_member_info.wxid
      //     setTimeout(()=>{
      //       this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
      //         robotid: sub_id,
      //         type: 'operationcapital',
      //         data: {
      //           id: [this.unclaimedList[i].id],
      //           type: '5',
      //         },
      //       })
      //     }, i*2000)
      //   }
      // }
    },

    // 通过审核
    handleAdopt(userInfo, type = '') {
      let sub_id = userInfo.sub_id
      let id = type ? userInfo.req_id : userInfo.id
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: sub_id,
        type: 'operationcapital',
        data: {
          id: [id],
          type: '1',
        },
      }).then(() => {
        this.countDown()
        this.getDrawMoneyStatus(sub_id, id)
      })
    },

    // 拒绝并返还
    handleReturn(userInfo, type = '') {
      let id = type ? userInfo.req_id : userInfo.id
      let sub_id = userInfo.sub_id
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: sub_id,
        type: 'operationcapital',
        data: {
          id: [id],
          type: '2',
        },
      }).then(result => {
        this.countDown()
        // if(type==="toBeReviewed"){
        this.getDrawMoneyStatus(sub_id, id)
        // }
      })
    },

    // 拒绝并扣除
    handleDeduction(userInfo, type = '') {
      let id = type ? userInfo.req_id : userInfo.id
      let sub_id = userInfo.sub_id
      // if(type)
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: sub_id,
        type: 'operationcapital',
        data: {
          id: [id],
          type: '3',
        },
      }).then(result => {
        this.countDown()
        // if(type==="toBeReviewed"){
        this.getDrawMoneyStatus(sub_id, id)
        // }
      })
    },

    // 红包销毁
    handleDestroy({ id, sub_id }) {
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: sub_id,
        type: 'operationcapital',
        data: {
          id: [id],
          type: '4',
        },
      }).then(result => {
        this.countDown()
      })
    },

    // 倒计时
    countDown() {
      let secondsToGo = 3
      const modal = this.$success({
        title: '操作指令已发送成功',
        content: `等待 ${secondsToGo} 秒后自动刷新数据`,
        class: 'count-down-modal',
        okText: '',
      })
      const interval = setInterval(() => {
        secondsToGo -= 1
        modal.update({
          content: `等待 ${secondsToGo} 秒后自动刷新数据`,
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        modal.destroy()
        if (this.errorMsg) {
          this.$message.error(this.errorMsg)
          this.$store.commit('WEBSOCKER_MUTATIONS_ERROR', { msg: '' })
          return
        }
        this.getData()
      }, secondsToGo * 1000)
    },

    // 将本页全部通过审核
    handleAllAdopt() {
      console.log('将本页全部通过审核')
      this.list.map(val => {
        this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
          robotid: val.sub_id,
          type: 'operationcapital',
          data: {
            id: [val.id],
            type: '1',
          },
        }).then(result => {
          this.countDown()
        })
        // return val.id
      })
    },

    handleFansDetail(userinfo, type = '') {
      if (userinfo && !type) {
        this.$refs.detaildrawer.show(this.currentRobotId, userinfo.uid)
      } else if (userinfo && type === 'toBeReviewed') {
        console.log(222222)
        this.$refs.detaildrawer.show(userinfo.sub_id, userinfo.member_id)
      }
    },

    handleFansOrder(userinfo, type, createdt) {
      if (userinfo && !type) {
        this.$refs.orderListModal.show({
          robotid: this.currentRobotId,
          uid: userinfo.uid,
          createdt: createdt,
        })
      } else if (userinfo && type === 'toBeReviewed') {
        this.$refs.orderListModal.show({
          robotid: userinfo.sub_id,
          uid: userinfo.member_id,
          createdt: userinfo.create_time,
        })
      }
    },

    handleFansLog(userinfo, type = '') {
      if (userinfo && !type) {
        this.$refs.log.show({
          robotid: this.currentRobotId,
          uid: userinfo.uid,
        })
      } else if (userinfo && type === 'toBeReviewed') {
        this.$refs.log.show({
          robotid: userinfo.sub_id,
          uid: userinfo.member_id,
        })
      }
    },

    onTabChange(key, type) {
      this[type] = key
    },

    // 过滤待审核列表
    filterToBeReviewedList() {
      this.toBeReviewedList.forEach(async item => {
        const res = await CapitalApi.getDrawMoneyStatus(item.sub_id, [item.req_id])
        if (res.data[0].status == 1) {
          this.removeFromToBeReviewedList(item.sub_id, item.req_id)
        } else if (res.data[0].status == 2) {
          this.removeFromToBeReviewedList(item.sub_id, item.req_id)
        } else if (res.data[0].status == 3) {
          this.removeFromToBeReviewedList(item.sub_id, item.req_id)
        }
      })
      setTimeout(() => {
        this.getAllToBeReviewedList()
      }, 2000)
    },

    // 获取全部待审核数据列表
    getAllToBeReviewedList(first = false) {
      this.loading = true
      CapitalApi.getAllToBeReviewedList(
        Object.assign(this.tbrQueryParam, {
          pageNo: first ? 1 : this.toBeReviewedPagination.current,
          pageSize: this.toBeReviewedPagination.pageSize,
        })
      )
        .then(res => {
          this.toBeReviewedPagination.current = res.pageNo
          this.toBeReviewedPagination.pageSize = res.pageSize
          this.toBeReviewedPagination.total = res.totalCount
          this.toBeReviewedList = res.data
          this.totalMoney = res.money
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 从全部待审核列表中删除
    async removeFromToBeReviewedList(sub_id, req_id) {
      const { code } = await CapitalApi.delFromAllToBeReviewedList(sub_id, req_id)
      if (code === 1) {
        this.getAllToBeReviewedList()
      }
    },

    // 获取提现状态
    getDrawMoneyStatus(sub_id, req_id) {
      let timer = setTimeout(async () => {
        const res = await CapitalApi.getDrawMoneyStatus(sub_id, [req_id])
        if (res.data[0].status == 1) {
          this.removeFromToBeReviewedList(sub_id, req_id)
        } else if (res.data[0].status == 2) {
          // console.log(res,'当前状态')
          this.removeFromToBeReviewedList(sub_id, req_id)
        }
        // this.getAllToBeReviewedList()
        clearTimeout(timer)
      }, 3500)
    },

    // 单个客户端的勾选框
    checkItem(item) {
      // console.log('选中的item=', item.id)
      // 第一次选中时，item里面没有这个checked属性，所以是undefined，要把这个加入到数组里面
      // console.log('item.checked==', item.checked)

      if (item.checked) {
        // 这个操作是：取消选择框时，要进行的操作
        this.$set(item, 'checked', false)
      } else if (item.checked == undefined) {
        this.passList.push(item)
        this.$set(item, 'checked', true)
      } else if (item.checked == false) {
        this.$set(item, 'checked', true)
        this.passList.push(item)
      }

      // 要过滤掉item.checked==false(也就是未选中的)的item
      this.passList = this.passList.filter(item => {
        return item.checked
      })
      // 数组去重
      // console.log('最终数组=', this.passList)
    },

    // 将勾选中的进行提交
    checkSubmit() {
      // 将这个数组全部通过审核的操作
      if (this.passList.length !== 0) {
        //#region 
        // this.passList.map((val,index) => {
        //   console.log('theLast=',theLast)
        //   this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        //     robotid: val.sub_id,
        //     type: 'operationcapital',
        //     data: {
        //       id: [val.id],
        //       type: '1'
        //     }
        //   }).then((result) => {
        //     this.countDown()
        //     // 清空这个数组
        //     // this.passList = []
        //     // 将选择框的状态清空
        //     this.$refs.inputCheck.map((item) => {
        //       item.checked = false
        //     })
        //   })
        // })
        //#endregion
        for (let i = 0; i < this.passList.length; i++) {
          setTimeout(() => {
            this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
              robotid: this.passList[i].sub_id,
              type: 'operationcapital',
              data: {
                id: [this.passList[i].id],
                type: '1',
              },
            })
              .then(result => {
                if (i + 1 == this.passList.length) {
                  // setTimeout(() => {
                  console.log('i=', i + 1)
                  this.countDown()
                  // 清空这个数组
                  // this.passList = []
                  // 将选择框的状态清空
                  // this.$refs.inputCheck.map((item) => {
                  //   item.checked = false
                  // })
                  // },4000)
                }
              })
              .catch(err => {
                console.log('err=', err)
              })
          }, i * 1500)
        }
      }
    },

    // 所有客户端的勾选框
    checkClient(item){
      // console.log('多个客户端的勾选框=', item)
      // console.log('选中的item=', item.id)
      // 第一次选中时，item里面没有这个checked属性，所以是undefined，要把这个加入到数组里面
      // console.log('item.checked==', item.checked)
      if (item.checked) {
        // 这个操作是：取消选择框时，要进行的操作
        this.$set(item, 'checked', false)
      } else if (item.checked == undefined) {
        this.allClientList.push(item)
        this.$set(item, 'checked', true)
      } else if (item.checked == false) {
        this.$set(item, 'checked', true)
        this.allClientList.push(item)
      }
      // 要过滤掉item.checked==false(也就是未选中的)的item
      this.allClientList = this.allClientList.filter(item => {
        return item.checked
      })
      // 数组去重
      // console.log('去重数组=', this.allClientList)
    },

    // 将所有客户端勾选中的提交
    checkClientSubmit(){
      console.log('所有客户端-提交通过=', this.allClientList)
      this.allClientList = []
      console.log('所有客户端-清空=', this.allClientList)
      // this.countDown()
    },
  },
}
</script>

<style lang="less" scoped>
.ant-avatar-lg {
  width: 48px;
  height: 48px;
  line-height: 48px;
}

.ant-list-item-meta {
  flex: 1;
}

.list-content-item {
  color: rgba(0, 0, 0, 0.45);
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 40px;

  span {
    line-height: 20px;
  }

  p {
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 22px;
  }
}

/deep/ .page-header {
  .extra {
    display: none;
  }

  .headerContent {
    flex: 0 1 100% !important;
  }
}

.count-down-modal .ant-modal-confirm-btns {
  display: none;
}

.ant-list-item-meta-title {
  width: 245px;
}
</style>
